import {Heading, Link} from '@primer/react'
import {ArrowRightIcon} from '@primer/octicons-react'
import styles from './MarketingSuggestion.module.css'

export default function MarketingSuggestion({
  title,
  description,
  cta,
  href,
  mediaPath,
  mediaPathRetina,
  mediaAlt,
}: {
  title: string
  description: string
  cta: string
  href: string
  mediaPath: string
  mediaPathRetina?: string
  mediaAlt: string
}) {
  let srcSet = `${mediaPath} 1x`
  if (mediaPathRetina) {
    srcSet += `, ${mediaPathRetina} 2x`
  }
  return (
    <div className={styles.container}>
      <div>
        <img src={mediaPath} alt={mediaAlt} srcSet={srcSet} />
      </div>
      <Heading as="h2" className={styles.heading}>
        {title}
      </Heading>
      <span className={styles.description}>{description}</span>
      <Link className={styles.ctaLink} href={href}>
        {cta} <ArrowRightIcon size={16} className={styles.ctaIcon} />
      </Link>
    </div>
  )
}
